<template>
    <div class="main-wrap mission-page">
        <div class="certificates-awards q-mb-lg">
            <h4>{{ $t('general.mission-vision-values') }}</h4>
        </div>

        <div class="row">
            <div
                v-for="mission in missions"
                :key="mission.id"
                class="brilliant col-xs-12 col-md-4"
            >
                <div class="package">
                    <div class="name">{{ mission.id }}</div>
                    <div class="trial">{{ mission.title }}</div>
                    <hr />
                    <hr />
                    <div class="content" v-html="mission.content"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'AboutCertificates',

    data() {
        return {
            missions: [
                {
                    id: '01',
                    title: 'Missão',
                    content:
                        'Contribuir para o desenvolvimento do sector petrolifero nacional através da formação de profissionais de excelência que atuam ao longo da cadeia de valor do sector petrolífero, marítimo e sectores complementares.',
                    icon: '',
                },
                {
                    id: '02',
                    title: 'Visão',
                    content:
                        'Ser uma instituição de formação técnica e profissional de referência a nível nacional e reconhecida internacionalmente, que opera de forma autónoma e independente.',
                    icon: '',
                },
                {
                    id: '03',
                    title: 'Valores',
                    content:
                        '<ul><li>Humildade</li><li>Disciplina e seriedade</li><li>Conduta ética</li><li>Alto desempenho</li><li>Respeito pelas partes interessadas</li><li>Trabalho em equipa</li><li>Lieldade</li><li>Rigor</li></ul>',
                    icon: '',
                },
            ],
        }
    },
}
</script>
<style lang="scss">
.mission-page {
    .brilliant {
        padding: 20px;

        .package {
            box-sizing: border-box;
            width: 100%;
            height: 420px;
            border: 3px solid #e8e8e8;
            border-radius: 7px;
            display: inline-block;
            padding: 24px;
            text-align: center;
            float: left;
            transition: margin-top 0.5s linear;
            position: relative;
            margin-right: 11px;
            border-color: #ffcc00;
        }
    }

    .name {
        color: #dc241f;
        font-weight: 400;
        font-size: 3rem;
        margin-top: -5px;
    }

    hr {
        background-color: #dedede;
        border: none;
        height: 1px;
    }

    .trial {
        font-size: 0.9rem;
        font-weight: 600;
        padding: 2px 21px 2px 21px;
        color: #dc241f;
        border: 1px solid #e4e4e4;
        display: inline-block;
        border-radius: 15px;
        background-color: white;
        position: relative;
        bottom: -15px;
    }

    .content {
        list-style: none;
        padding: 0;
        text-align: left;
        margin-top: 29px;
        color: #616161;
        font-size: 18px;
    }

    ul {
        list-style: none;
        padding: 0;
        text-align: left;
        margin-top: 29px;
    }

    li {
        // margin-bottom: 15px;
        &:before {
            @extend .checkIcon;
            color: #ffcc00;
            // font-size: 1.3rem;
            margin-right: 5px;
        }
    }

    .checkIcon {
        font-family: 'Font Awesome 5 Free';
        content: '\f111';
        font-weight: 900;
        font-size: 9px;
        position: relative;
        top: -1px;
    }
}
</style>
